import { render, staticRenderFns } from "./SectionArray.vue?vue&type=template&id=56592f90&"
import script from "./SectionArray.vue?vue&type=script&lang=js&"
export * from "./SectionArray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56592f90')) {
      api.createRecord('56592f90', component.options)
    } else {
      api.reload('56592f90', component.options)
    }
    module.hot.accept("./SectionArray.vue?vue&type=template&id=56592f90&", function () {
      api.rerender('56592f90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/FormBuilder/SectionArray.vue"
export default component.exports